import { createReducer } from '@reduxjs/toolkit';

import { setBreakpoint } from './actions';
import { BREAKPOINT_1004 } from './constants';

export const adaptivityReducer = createReducer(BREAKPOINT_1004, {
  [setBreakpoint.type]: (state, action) => action.payload,
});
